export function isIpad() {
  return /iPad/.test(navigator.userAgent);
}

export function isIpod() {
  return /iPod/.test(navigator.userAgent);
}

export function isIphone() {
  return /iPhone/.test(navigator.userAgent);
}

export function isIos() {
  return isIpad() || isIpod() || isIphone();
}

export function isWindowsInTabletMode() {
  // can we just detect touch points and enable if on?
  return /Win/.test(navigator.platform) && navigator.maxTouchPoints > 0;
  // return navigator.maxTouchPoints > 0;
}

export function isAndroid() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Android/.test(userAgent);
}

/**
 * TODO: [Tyler] Basing features on device type is not recommended generally
 *       Need to move to check instead for what is supported by the device/browser
 */
export function isMobile() {
  return /Mobile/.test(navigator.userAgent) || isIos() || isWindowsInTabletMode();
}

export default {
  isIpad,
  isIpod,
  isIphone,
  isIos,
  isWindowsInTabletMode,
  isAndroid,
};
